import { nonEmptyStringValidator } from '@vista/omnichannel-components-domain';
import { Validator } from '@vista-digital/validator';
import { defaultSingleItemPickerAssets, singleItemPickerAssetsValidator } from '../../../single-item-picker/types/assets';
import { defaultSingleItemPickerCdnOptions, singleItemPickerCdnOptionsValidator } from '../../../single-item-picker/types/cdn-options';
import { singleItemPickerEventsValidator } from '../../../single-item-picker/types/events';
import { defaultThreeDGlassesPickerConfig, threeDGlassesPickerConfigValidator } from './config';
import { defaultThreeDGlassesPickerDisplayText, threeDGlassesPickerDisplayTextValidator } from './display-text';
export const threeDGlassesPickerValidator = Validator.object({
    itemHopk: nonEmptyStringValidator,
    displayText: threeDGlassesPickerDisplayTextValidator,
    config: threeDGlassesPickerConfigValidator,
    assets: singleItemPickerAssetsValidator,
    events: singleItemPickerEventsValidator,
    cdnOptions: singleItemPickerCdnOptionsValidator
});
/**
 * Default props for the 3D Glasses Picker component.
 */
export const defaultThreeDGlassesPickerProps = {
    itemHopk: undefined,
    displayText: defaultThreeDGlassesPickerDisplayText,
    config: defaultThreeDGlassesPickerConfig,
    assets: defaultSingleItemPickerAssets,
    events: {},
    cdnOptions: defaultSingleItemPickerCdnOptions
};
